// src/services/roleService.js
import api from './api';

/**
 * Получает список доступных ролей для текущего пользователя
 * Роли фильтруются на бэкенде по правам
 */
export const getAllRoles = async () => {
  try {
    const res = await api.get('/roles');
    return res.data || [];
  } catch (err) {
    console.error('Ошибка при загрузке ролей:', err);
    return [];
  }
};